import { render, staticRenderFns } from "./InfoModal.vue?vue&type=template&id=82e7a4c2&scoped=true"
import script from "./InfoModal.vue?vue&type=script&lang=ts"
export * from "./InfoModal.vue?vue&type=script&lang=ts"
import style0 from "./InfoModal.vue?vue&type=style&index=0&id=82e7a4c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e7a4c2",
  null
  
)

export default component.exports